import { type FontScale, useFontScale } from '@qi/ui';
import { useEffect, useRef } from 'react';
import { useMe } from './queries.ts';

function isFontScale(v: unknown): v is FontScale {
  return v === 'default' || v === 'large' || v === 'larger';
}

/**
 * Hydrates the text-size preference from the signed-in profile (the
 * cross-device source of truth) into FontScaleProvider. Runs ONCE when the
 * profile first resolves: applying it on every change would clobber an
 * optimistic local change in the window before the mutation's refetch lands.
 * Guests / signed-out users keep the localStorage (or default) value. Mount
 * once at the root, inside FontScaleProvider.
 */
export function FontScaleSync() {
  const { data } = useMe();
  const { setFontScale } = useFontScale();
  const hydrated = useRef(false);

  useEffect(() => {
    if (hydrated.current) return;
    const serverScale = data?.profile?.fontScale;
    if (isFontScale(serverScale)) {
      hydrated.current = true;
      setFontScale(serverScale);
    }
  }, [data, setFontScale]);

  return null;
}
